export const isElectronEnvironment = () => {
  if (typeof navigator === "undefined" || !navigator.userAgent) {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf("electron/") > -1;
};
